import { uploadsSelectors } from '@anm/store/modules/uploads';
import useVideoStatusChecker from '@anm/hooks/useVideoStatusChecker';
import { supportedExtensions } from '@anm/hosting-player';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import vtConfig from '../../../../config';
import { videoFolderActions } from '../../../../store/modules/videoFolder';

type CreateProjectProps = {
  hostId: string;
  isNewVideo: boolean;
  uploadId?: string;
};

const { urls } = vtConfig();

const useCreateProject = ({ hostId, uploadId, isNewVideo }: CreateProjectProps) => {
  const dispatch = useDispatch();

  const isUploadCompleted = useSelector(state => uploadsSelectors.selectIsUploadCompleted(state, uploadId));
  const fetchManifestProgress = isUploadCompleted && isNewVideo ? 100 : null;

  const { isMediaReady: isVideoReady } = useVideoStatusChecker({
    hostId,
    source: 'api',
    supportedExtensions,
    progress: fetchManifestProgress,
    uploadCheckerUrl: `${urls.apiWave}v2/media/${uploadId}`
  });

  useEffect(() => {
    if (!isVideoReady) return;

    dispatch(videoFolderActions.createProject());
  }, [isVideoReady]);
};

export default useCreateProject;
